import UndoIcon from '@atlaskit/icon/core/undo';
import * as React from 'react';

export function SvgUndoAlt() {
  return <UndoIcon label="" testId="ads-refreshed-icon" />;
}
